import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TrackingTimelineResponse } from 'src/app/model/trackingTimelineResponse.model';
import { AtInternetService } from 'src/app/services/at-internet.service';

@Component({
  selector: 'app-bloc-commercial',
  templateUrl: './bloc-commercial.component.html',
  styleUrls: ['./bloc-commercial.component.scss']
})
export class BlocCommercialComponent implements OnInit {

  showMe: boolean = true;
  toggleStyle: boolean = false;
  @Input() parcelInformations: TrackingTimelineResponse;
  @Input() tag;

  constructor(private atInternetService: AtInternetService) { }

  ngOnInit(): void {
  }

  closeBloc(): void {
    this.showMe = false;
  }

  generateTagClick(){
    this.atInternetService.generateClickAction(
      this.tag,
      'cobranding',
      'lien_banniere'
    );
  }
  
  @HostListener('window:scroll', [])
  onScroll(): void {
    if (document.getElementById('blocCommercial') !== null
    && document.getElementById('blocCommercial').getBoundingClientRect() != null
    && document.getElementById('blocCommercial').getBoundingClientRect().bottom != null
    && window.innerHeight != null) {
      if (Math.round(document.getElementById('blocCommercial').getBoundingClientRect().bottom) === Math.round(window.innerHeight)) {
        this.toggleStyle = false;
      } else {
        this.toggleStyle = true;
      }
    }
  }
  

}
